require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2006-10-finally-all-back-in-business.json") })
        }
      }, "path---articles-2006-10-finally-all-back-in-business");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2006-10-finally-all-back-in-business!./.cache/json/articles-2006-10-finally-all-back-in-business.json
// module id = 374
// module chunks = 231608221292675